import React from 'react';
import { Tooltip } from '@material-ui/core';

import { fieldsTypes, dateTimeDisplayTypes, dateTimeFormats } from 'config/constants';
import { renderDateTime } from 'helpers/dateTimeHelper';
import { renderBooleanValue, getBooleanText } from 'helpers/fieldsHelper';
import { getImageLink } from 'helpers/imageHelper';
import TableImageItem from 'containers/ScrollableTable/TableImageItem';

// The one place a field type's table behaviour is defined. Each entry may
// supply render (the cell), copyText (clipboard) and measureText (the text
// whose width sizes the column); anything left out uses the default below.
// Adding a type means adding one entry here.

function getTextWidth(text, font) {
  var canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement('canvas'));
  var context = canvas.getContext('2d');
  context.font = font;
  return context.measureText(text).width;
}

function renderDefault(value) {
  var rowWidth = getTextWidth(value, 'normal 8pt arial');
  return (
    <>
      {rowWidth > 325 || (value && value.toString().length > 35)
        ? <Tooltip title={value}>
            <div className="body-cell-value">
              <div className="body-cell-value-inner">{value && value.toString()}</div>
            </div>
          </Tooltip>
        : <div className="body-cell-value">
            <div className="body-cell-value-inner">{value && value.toString()}</div>
          </div>}
    </>
  );
}

function isDateDisplay(column) {
  return column.displayType === dateTimeDisplayTypes.DATE;
}

function dateDisplayText(value, column) {
  return isDateDisplay(column) ? renderDateTime(value, dateTimeFormats.DATE) : renderDateTime(value);
}

function imageCopyText(value) {
  return getImageLink(value, []);
}

function imageMeasureText() {
  return '';
}

var NO_ENTRY = {};

var FIELD_TYPES = {};

FIELD_TYPES[fieldsTypes.DATETIME] = {
  render: function (value, column) {
    return (
      <div className="body-cell-value">
        <div className="body-cell-value-inner">
          {value ? dateDisplayText(value, column) : '-'}
        </div>
      </div>
    );
  },
  copyText: function (value, column) {
    return renderDateTime(value, isDateDisplay(column) ? dateTimeFormats.DATE : dateTimeFormats.DATE_TIME);
  },
  measureText: dateDisplayText,
};

FIELD_TYPES[fieldsTypes.PHOTO] = {
  render: function (value) {
    return value === true ? (
      <div className="body-cell-image">
        <div className="image-loader" style={{ width: 40, height: 40, borderRadius: 5 }}>
          <div className="image-loader-shimmer" style={{ borderRadius: 5 }} />
        </div>
      </div>
    ) : (
      <TableImageItem imageUUID={value} />
    );
  },
  copyText: imageCopyText,
  measureText: imageMeasureText,
};

FIELD_TYPES[fieldsTypes.EMAIL] = {
  render: function (value) {
    var isValueString = typeof value === 'string';
    return (
      <div className="body-cell-value-inner-email-container">
        {isValueString && value ? (
          <div className="body-cell-value">
            <div className="body-cell-value-inner">{value.toString()}</div>
          </div>
        ) : (
          value && value.map(function (email) { return <div className="body-cell-value-inner-email">{email}</div>; })
        )}
      </div>
    );
  },
};

FIELD_TYPES[fieldsTypes.IMAGE] = {
  render: function (value, column, ctx) {
    return !ctx.showEmptyImages && !value ? (
      '-'
    ) : (
      <TableImageItem
        large={ctx.rowHeightPreset === 'large'}
        imageUUID={value}
        isExpandable={ctx.isImageExpandable}
      />
    );
  },
  copyText: imageCopyText,
  measureText: imageMeasureText,
};

FIELD_TYPES[fieldsTypes.BOOLEAN] = {
  render: function (value, column) {
    return renderBooleanValue(column.displayType, value);
  },
  copyText: function (value, column) {
    return getBooleanText(column.displayType, value);
  },
};

FIELD_TYPES[fieldsTypes.ACTIONS] = {
  render: function (value) {
    return <div className="body-cell-value">{value}</div>;
  },
};

function entryFor(column) {
  return (column && FIELD_TYPES[column.type]) || NO_ENTRY;
}

export function renderFieldCell(value, column, ctx) {
  if ((value === '' || value === undefined) && column.type !== fieldsTypes.IMAGE) {
    return '-';
  }
  var render = entryFor(column).render || renderDefault;
  return render(value, column, ctx || {});
}

export function fieldCellCopyText(value, column) {
  if (value === '') return '-';
  var copyText = entryFor(column).copyText;
  return copyText ? copyText(value, column) : value;
}

export function fieldCellMeasureText(value, column) {
  var measureText = entryFor(column).measureText;
  return measureText ? measureText(value, column) : value;
}
